import { styled } from '@mui/material';
import { Grid } from '@mui/material';
import Button from 'components/Button';
import ButtonGroup from 'components/ButtonGroup';
import Heading from 'components/Heading';

type HeaderProps = {
  setIsEditing: (isEditing: boolean) => void;
  isEditing: boolean;
  editingHoldingClassId?: string;
  onUpdateHoldingClass: (holdingClassId: string) => void;
  isUpdatingHoldingClass: boolean;
};

const StyledButtonGroup = styled(ButtonGroup)({
  justifyContent: 'flex-start',
});

const StyledHeading = styled(Heading)(({ theme }) => ({
  margin: 0,
  [theme.breakpoints.down('md')]: {
    marginBottom: theme.spacing(2),
    width: '100%',
  },
}));

const ClassHoldingsHeader: React.FC<HeaderProps> = ({
  setIsEditing,
  isEditing,
  editingHoldingClassId,
  onUpdateHoldingClass,
  isUpdatingHoldingClass,
}) => {
  return (
    <Grid container>
      <Grid size={{ md: 3, xs: 12 }} alignContent="center">
        <StyledHeading variant="h2">Class rights</StyledHeading>
      </Grid>
      <Grid size={{ md: 7, xs: 12 }}>
        <StyledButtonGroup>
          {isEditing && editingHoldingClassId ? (
            <>
              <Button
                variant="contained"
                color="primary"
                loading={isUpdatingHoldingClass}
                fullWidth
                onClick={async () => {
                  await onUpdateHoldingClass(editingHoldingClassId);
                  setIsEditing(false);
                }}
              >
                Save changes
              </Button>
              <Button
                variant="contained"
                color="error"
                fullWidth
                onClick={() => setIsEditing(false)}
              >
                Cancel
              </Button>
            </>
          ) : (
            <Button
              variant="contained"
              color="primary"
              onClick={() => setIsEditing(!isEditing)}
            >
              Edit
            </Button>
          )}
        </StyledButtonGroup>
      </Grid>
    </Grid>
  );
};

export default ClassHoldingsHeader;
